export default __webpack_public_path__ + "static/media/type-takeover.a2197236.svg";